import {Component, ElementRef, OnInit} from '@angular/core';
import { UtilFns } from '../../utils/common';
import { ModalDialog } from '../../controls/common';

import {UnitOfWork} from '../../services/common';
import { RIFMContent } from '../../entities/EntityModels';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'tools-and-models-license',
    templateUrl: './tools-and-models-license.html',
})
export class ToolsAndModelsLicenseComponent extends ModalDialog<boolean> implements OnInit {
    public _rifmProductLicense: SafeHtml;

    constructor(public elementRef: ElementRef, public _uow: UnitOfWork, public _sanitizer: DomSanitizer) {
        super(elementRef);
    }

    ngOnInit() {
        const params = { contentName: 'RIFMProductLicense' };
        return this._uow.fetchText('Misc/RIFMContentByName', params).then(fn => {
            if (fn != null && fn.length > 0) {
                this._rifmProductLicense = this._sanitizer.bypassSecurityTrustHtml(fn);
            }
        });
    }

    onAccept(accept: boolean) {
        UtilFns.returnModal(this, accept);
    }

}

